module.exports = __webpack_public_path__ + "img/7.d404063b.jpg";